import $ from 'jquery';

function fixWrapperHeight() {
  // Get and set current height
  const headerH = 62;
  const footer = 170;
  const footerMap = 210;
  const navigationH = $('#navigation').height();
  const contentH = $('.content').height();

  // Set new height when contnet height is less then navigation
  if (contentH < navigationH) {
    $('#wrapper').css('min-height', `${navigationH}px`);
    $('#network_pane').css('min-height', `${navigationH - footer}px`);
    $('#networkMap').css('min-height', `${navigationH - footerMap}px`);
  }

  // Set new height when contnet height is less then navigation and navigation is less then window
  if (contentH < navigationH && navigationH < $(window).height()) {
    $('#wrapper').css('min-height', `${$(window).height() - headerH}px`);
    $('#network_pane').css(
      'min-height',
      `${$(window).height() - headerH - footer}px`,
    );
    $('#networkMap').css(
      'min-height',
      `${$(window).height() - headerH - footerMap}px`,
    );
  }

  // Set new height when contnet is higher then navigation but less then window
  if (contentH > navigationH && contentH < $(window).height()) {
    $('#wrapper').css('min-height', `${$(window).height() - headerH}px`);
    $('#network_pane').css(
      'min-height',
      `${$(window).height() - headerH - footer}px`,
    );
    $('#networkMap').css(
      'min-height',
      `${$(window).height() - headerH - footerMap}px`,
    );
  }
}

export default fixWrapperHeight;
